module.exports = __webpack_public_path__ + "img/resource-tech-image-25.0e5db44d.jpg";